import { render, staticRenderFns } from "./assets-filters.vue?vue&type=template&id=08f7a46c&scoped=true&"
import script from "./assets-filters.vue?vue&type=script&lang=js&"
export * from "./assets-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7a46c",
  null
  
)

export default component.exports